import type { BrowserOptions, NodeOptions } from "@sentry/nextjs";

// cspell: ignore adnxs xsca ampproject amphtml vpaid tinypass moatvideo ftpagefold_ pagead sdkloader lastpass crwdcntrl doubleverify adsystem adlooxtracking connatix googlesyndication Lotame rubiconproject
export const sentryConfig: BrowserOptions | NodeOptions = {
  attachStacktrace: true,
  denyUrls: [
    // Chrome extensions
    /^chrome-extension:\/\//i,
    /^chrome:\/\//i,
    /extensions\//i,
  ],
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN ?? "",
  ignoreErrors: [
    "Access is denied for this document",
    "Ad request reached a timeout",
    "An attempt was made to break through the security policy of the user agent",
    "Blocked a restricted frame",
    "Cannot remove a child from a different parent",
    "Cannot return null for non-nullable field",
    "captured as promise rejection",
    "ezproxy",
    "Failed to get image",
    "Failed to register a ServiceWorker",
    "Invalid URL",
    "Invariant: attempted to hard navigate to the same URL",
    "Missing required parameters: sitekey",
    "N+1 API Call",
    "Non-Error promise rejection captured with value",
    "Request aborted",
    "Request failed with status code 401",
    "Request failed with status code 403",
    "ResizeObserver loop completed with undelivered notifications",
    "ServiceWorker script",
    "SYNC.JS",
    "The ad response was not understood and cannot be parsed",
    "The browser prevented playback initiated without user interaction",
    "The browser you are using isn't compatible with this application",
    "The operation is insecure",
    "The request is not allowed by the user agent",
    "The response does not contain any valid ads",
    "The source window of session client post messages cannot be changed from the source of the first message",
    "There was a problem requesting ads from the server",
    "This Suspense boundary received an update before it finished hydrating",
    "URL is not a constructor",
    "value of `payload` must be string or number or non-empty array of string",
    /Abort\s?Error/i,
    /Cannot read properties of undefined \(reading '__(\w+)'\)/i,
    /Failed to execute '(\w+)' on '(Node|Window)'/i,
    /googletag\.(\w+) is not a function/i,
    /Network\s?Error/i,
    /timeout( of \d+ms)? exceeded/i,
  ],
  // cspell: disable-line
  release: process.env.NEXT_PUBLIC_COMMIT_SHA,
};
